<template>
	<span v-if="useArmId === undefined" style="color: red"
		>В метаданных не указан ID АРМ выбора! Выбор записи невозможен</span
	>
	<div ref="wrapperDropdown" v-else class="dropdown_query lm-dropdown-wrap">
		<div :class="{ active: statusOpenForm }">
			<div class="lm-dropdown" :class="{ open: statusOpenForm }">
				<i @click="focusInput" v-if="!statusLoader && arrayValues.length" ref="icon" class="lm-dropdown-icon" />

				<div v-if="statusLoader" class="spin-position spin-lg-container">
					<i class="spin spin-lg" data-test-id="load_animation" />
				</div>

				<label class="w-100">
					<input
						:placeholder="this.c_ctrlParams.customPlaceholder || 'Название станции'"
						:data-test-id="c_test_attrs['test-dbcolname']"
						@focus="focusInput"
						@focusout="focusOut"
						ref="search"
						class="form-control d-input"
						v-model="inputValue"
						type="text"
					/>
				</label>
			</div>

			<div class="lm-dropdown-menu" ref="dropdown">
				<ul :style="{ 'max-height': maxHeight }" ref="dropdownElement">
					<li style="display: flex" v-for="(el, idx) in arrayValues" :key="idx">
						<!--				если не задан формат вывода в админке, то будет выведиться так
												Шаблон express_code || nsi_id - name - railway_id
						-->
						<span v-if="!frontFieldsName.length" class="lm-dropdown-menu--item" @click="select(el.fields)">
							{{ el.fields[6] && el.fields[6].value ? el.fields[6].value : el.fields[5].value }} -
							{{ el.fields[1].value }} - {{ el.fields[3].value }}
						</span>

						<template v-else>
							<span v-for="field in frontFieldsName" :key="field">
								<template v-for="(e, e_i) in el.fields">
									<span
										v-if="e.fieldId === field && e.value"
										@click="select(el.fields)"
										class="lm-dropdown-menu--item"
										:key="e.fieldId"
									>
										{{ e.value }}
										<template v-if="c_ctrlParams.delimiter && e_i !== el.fields.length - 1">
											{{ c_ctrlParams.delimiter }}&nbsp;
										</template>
									</span>
								</template>
							</span>
						</template>
					</li>

					<template v-if="inputValue.length >= 3 && !statusLoader">
						<li v-if="!arrayValues.length && inputValue.length !== 0" class="no-options">
							<span class="lm-dropdown-menu--item">К сожалению, ничего не найдено.</span>
						</li>
					</template>
				</ul>
			</div>
		</div>

		<div class="help-block"></div>
		<div class="ctrl-extraDescr" v-if="c_ctrlParams.extraDescr" v-html="c_ctrlParams.extraDescr"></div>
	</div>
</template>

<script>
import ctrlMixins from './_mixins.js';
import urlUtil from '@uarmRoot/src/util-url';
import axios from 'axios';
import { ctrlParamsForAll, selectFieldsFromDatabase } from './_common-stuff.ts';

export default {
	name: 'ctrl_dropdown_query',
	mixins: [ctrlMixins], // c_value, c_ctrlParams, c_srv_options, пропсы view_type, field_meta и так далее
	meta: {
		// это наши данные, т.е. вуй при объявлении компонента их не использует
		title: 'Выпадающий список с запросом на АРМ',
		params: {
			useArmId: {
				name: 'АРМ',
				editType: 'armpicker',
			},
			fieldDatabase: {
				name: 'колонка, по которому будет идти поиск',
				editType: 'selectFieldsFromDatabase',
			},
			selectFieldsFromDatabase,
			customPlaceholder: {
				name: 'Placeholder',
				editType: 'input',
				default: '',
			},
			delimiter: {
				name: 'Разделитель между значениями',
				tip: 'Символы, вставляемые между значениями, которые попадут на фронт. По умолчанию - пробел.',
				editType: 'input',
				default: ' ',
			},
			...ctrlParamsForAll,
		},
	},
	props: {
		maxHeight: {
			type: String,
			default: '200px',
		},
		value: {
			default() {
				// параметр контрола defaultValue имеет более высокий приоритет
				// и применяется на более высоком уровне, тут речь только о ситуации когда ни значения ни defaultValue нет
				return this.view_type === 'filter' ? '' : null;
			},
		},
	},
	data: () => ({
		arrayValues: [],
		inputValue: '',
		useArmId: null,
		baseUrl: '',
		constQuery: '&pageSize=1000&sortingField=id&sortingDirection=DESC',
		timeout: null,
		bodyElem: null,

		statusOpenForm: false, // открытие формы
		statusLoader: false, // loader
		statusSendQuery: true, // когда выбрали что то из списк, чтобы этот выбор на отправился на сервер
		fieldDatabase: 'name', // по этой колонке идет поиск в базе

		frontFieldsName: [], // поля из базы, которые будут отображенны на морде
	}),
	watch: {
		inputValue() {
			if (!this.c_ctrlParams.useArmId) {
				console.log('Выберите "Параметры контрола АРМ"');
				return;
			}
			if (!this.inputValue.length) {
				this.arrayValues.length = 0;
			}
			if (this.inputValue.length >= 3 && this.statusSendQuery) {
				clearTimeout(this.timeout);
				this.timeout = setTimeout(() => {
					this.sendQuery();
				}, 1000);
			} else {
				clearTimeout(this.timeout);
			}
			this.statusSendQuery = true;
		},
	},
	mounted() {
		this.frontFieldsName = Array.isArray(this.c_ctrlParams.selectFieldsFromDatabase)
			? this.c_ctrlParams.selectFieldsFromDatabase
			: [];
		this.fieldDatabase = this.c_ctrlParams.fieldDatabase ? this.c_ctrlParams.fieldDatabase : 'name';
		this.useArmId = this.c_ctrlParams.useArmId;
		this.baseUrl =
			urlUtil.getDomain() + urlUtil.getPath() + this.$route.params.vpId + '/' + this.c_ctrlParams.useArmId + '/data';
		this.bodyElem = document.querySelector('body');

		if (this.value) {
			this.statusLoader = true;
			axios
				.get(`${this.baseUrl}?id=${this.value}`)
				.then(({ data }) => {
					this.statusSendQuery = false;
					this._renderFront(data.records[0].fields);
					this.statusLoader = false;
				})
				.catch((e) => {
					console.log(e);
				});
		}
	},
	methods: {
		_renderFront(arr) {
			if (!this.frontFieldsName.length) {
				this.inputValue = `${arr[6].value ? arr[6].value : arr[5].value} - ${arr[1].value} - ${arr[3].value}`;
			} else {
				let obj = {};
				arr.forEach((el) => {
					obj[el.fieldId] = { value: el.value };
				});
				this.inputValue = this.frontFieldsName.map((name) => {
					if (obj[name]) {
						return obj[name].value;
					}
				});
				this.inputValue = this.inputValue.join(this.c_ctrlParams.delimiter);
			}
		},
		focusInput() {
			if (this.arrayValues.length) {
				this._handleOpenDropdown();
			}
		},
		focusOut() {
			if (!this.inputValue) {
				// сохранение обнулённого значения после снятия фокуса с элемента
				this.$emit('update:value', null);
				this.mixin_inputEvent({
					ctrlCode: this.$props.field_meta.ctrlCode,
					dbcolname: this.$props.field_meta.dbcolname,
					evtType: 'onSelect',
					fullValue: {},
				});
				this.mixin_saveEvent();
			}
		},
		_handleOpenDropdown() {
			this.statusOpenForm = true;
			this.bodyElem.addEventListener('click', this._handleToggleDropdown);
		},
		_handleCloseDropdown() {
			this.statusOpenForm = false;
			this.bodyElem.removeEventListener('click', this._handleToggleDropdown, false);
		},
		_handleToggleDropdown(e) {
			if (e.target.parentElement !== this.$refs.dropdownElement && e.target !== this.$refs.search) {
				this._handleCloseDropdown();
			}
		},
		sendQuery() {
			this.statusLoader = true;
			axios
				.get(this.baseUrl + `?${this.fieldDatabase}=${this.inputValue}${this.constQuery}`)
				.then(({ data }) => {
					this.arrayValues.length = 0;
					this.arrayValues.push(...data.records);
					this._handleOpenDropdown();
					this.statusLoader = false;
				})
				.catch((e) => {
					console.log(e.response);
				});
		},
		select(arr) {
			const id = arr[0].value;
			const name = arr[1].value;
			this.statusSendQuery = false;

			this._renderFront(arr);

			this.$emit('update:value', id);
			this.mixin_inputEvent({
				ctrlCode: this.$props.field_meta.ctrlCode,
				dbcolname: this.$props.field_meta.dbcolname,
				evtType: 'onSelect',
				fullValue: {
					id: id,
					name: name,
				},
			});
			this.mixin_saveEvent();
			this._handleCloseDropdown();
		},
	},
};
</script>

<style lang="css">
.lm-dropdown-menu--item {
	display: block;
}
.w-100 {
	width: 100%;
}

.lm-dropdown-wrap {
	position: relative;
}

.dropdown_query .lm-dropdown-menu {
	display: none;
	position: absolute;
	z-index: 10;
	background: #fff;
	width: 100%;
}

.dropdown_query .lm-dropdown-menu ul {
	padding: 0;
	list-style: none;
	overflow: auto;

	width: 100%;
	cursor: pointer;
	background-color: #fff;
	border: 1px solid #cbd0d8;
	border-radius: 0 0 4px 4px;
	box-shadow: 0 4px 16px 0 rgba(40, 42, 54, 0.16);
}

.dropdown_query .lm-dropdown-menu li {
	width: 100%;
	color: #282a36;
	display: block;
	font-size: 14px;
	overflow: hidden;
	padding: 4px 14px;
	white-space: nowrap;
	text-decoration: none;
	text-overflow: ellipsis;
	cursor: pointer;
}

.lm-dropdown-menu li:hover {
	color: #0063da;
	background-color: rgba(76, 159, 159, 0.15);
}

.lm-dropdown-wrap .active .lm-dropdown-menu {
	display: block;
}

.dropdown_query .spin-lg:after {
	font-size: 1em;
}

.dropdown_query .spin-lg {
	padding: 0;
}

.dropdown_query .spin-position {
	top: 4px;
	right: 14px;
	width: 10px;
	height: 6px;
	display: block;
	cursor: pointer;
	position: absolute;
}

.dropdown_query .form-control {
	font-weight: 500;
}

/* .dropdown_query .lm-dropdown-menu--item:last-child .delimiter {
	display: none;
} */
</style>
